import { jwtDecode } from "jwt-decode";

/**
 * Render-gate for the AI-generated clinical history UI.
 *
 * Returns true ONLY when BOTH conditions hold:
 *   1. The user's JWT carries `features.AIHistory === true`
 *   2. The user's role array includes "Practitioner" OR "SystemAdmin"
 *      (SystemAdmin gets visibility for support/debugging — they're the only
 *      role that can flip the AIHistory flag, so they need to see what they
 *      enabled.)
 *
 * Mirrors the pattern used by SyncToButton.readFlagFromJwt — JWT-based, so a
 * stale token after a server-side feature change still gates correctly until
 * the next login. UX-only; backend routes still enforce auth + practice
 * ownership independently.
 */
const ALLOWED_ROLES = new Set(["Practitioner", "SystemAdmin"]);

export function userCanSeeClinicalHistory() {
  try {
    const token = sessionStorage.getItem("user");
    if (!token) return false;
    const decoded = jwtDecode(token);

    const hasFeature = !!decoded?.features?.AIHistory;
    if (!hasFeature) return false;

    const rawRoles = decoded?.role ?? decoded?.roles;
    const roles = Array.isArray(rawRoles)
      ? rawRoles
      : rawRoles
        ? [rawRoles]
        : [];
    const hasAllowedRole = roles.some((r) => ALLOWED_ROLES.has(r));

    return hasFeature && hasAllowedRole;
  } catch (_e) {
    return false;
  }
}
